module.exports = __webpack_public_path__ + "static/img/mapR.5c809bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutpic/mapR.png
// module id = d/6P
// module chunks = 51